var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactPhoneIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_830_268)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 52,
    height: 52,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 44.229C49 44.697 48.8958 45.178 48.6745 45.646C48.4532 46.114 48.1668 46.556 47.7892 46.972C47.1512 47.674 46.4482 48.181 45.654 48.506C44.8728 48.831 44.0265 49 43.1152 49C41.7872 49 40.3681 48.688 38.8708 48.051C37.3736 47.414 35.8763 46.556 34.3921 45.477C32.8794 44.3721 31.4519 43.1554 30.1217 41.837C28.8051 40.5136 27.5908 39.0925 26.4892 37.586C25.4216 36.104 24.5623 34.622 23.9374 33.153C23.3125 31.671 23 30.254 23 28.902C23 28.018 23.1562 27.173 23.4687 26.393C23.7812 25.6 24.2759 24.872 24.9659 24.222C25.7992 23.403 26.7106 23 27.674 23C28.0386 23 28.4031 23.078 28.7286 23.234C29.0671 23.39 29.3666 23.624 29.6009 23.962L32.6214 28.213C32.8558 28.538 33.025 28.837 33.1422 29.123C33.2594 29.396 33.3245 29.669 33.3245 29.916C33.3245 30.228 33.2334 30.54 33.0511 30.839C32.8818 31.138 32.6345 31.45 32.322 31.762L31.3325 32.789C31.1893 32.932 31.1242 33.101 31.1242 33.309C31.1242 33.413 31.1372 33.504 31.1632 33.608C31.2023 33.712 31.2414 33.79 31.2674 33.868C31.5018 34.297 31.9054 34.856 32.4782 35.532C33.0641 36.208 33.689 36.897 34.366 37.586C35.0691 38.275 35.7461 38.912 36.4362 39.497C37.1132 40.069 37.673 40.459 38.1157 40.693C38.1808 40.719 38.2589 40.758 38.35 40.797C38.4542 40.836 38.5583 40.849 38.6755 40.849C38.8968 40.849 39.0661 40.771 39.2093 40.628L40.1988 39.653C40.5243 39.328 40.8368 39.081 41.1362 38.925C41.4357 38.743 41.7351 38.652 42.0606 38.652C42.308 38.652 42.5684 38.704 42.8548 38.821C43.1412 38.938 43.4407 39.107 43.7662 39.328L48.0756 42.383C48.4141 42.617 48.6485 42.89 48.7917 43.215C48.9219 43.54 49 43.865 49 44.229Z",
    stroke: "#5056FD",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_830_268",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_830_268"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_830_268"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_830_268",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhoneIc);
export default __webpack_public_path__ + "static/media/contactPhone_ic.22d4f305203558b40348f734f75d7233.svg";
export { ForwardRef as ReactComponent };